import PopupBasic from 'src/game/components/popups/PopupBasic';
import View from '@play-co/timestep-core/lib/ui/View';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import bitmapFonts from 'src/lib/bitmapFonts';
import i18n from 'src/lib/i18n/i18n';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import uiConfig from 'src/lib/ui/config';
import ButtonView from '@play-co/timestep-core/lib/ui/widget/ButtonView';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import StateObserver from 'src/StateObserver';
import { trackToSConfirm, trackToSView } from 'src/lib/analytics/events';

export default class PopupTermsPolicy extends PopupBasic {
  constructor(private creationOpts: { superview: View; close: () => void }) {
    super({
      ...creationOpts,
      height: 590,
      width: 530,
      skipMessage: true,
      darkerBg: true,
      tracking: { feature: 'terms', $subFeature: 'popup-terms-policy' },
    });

    this.root.updateOpts({ zIndex: 10002 });
    this.bg.updateOpts({ opacity: 0.95 });
    this.buttonClose.hide();

    const locale = StateObserver.getState().ui.locale;

    // Default font with english
    let paragraphOneX = 133;
    let paragraphOneY = 221;
    let paragraphTwoX = 147;
    let paragraphTwoY = 262;
    let lineOneWidth = 265;
    let lineTwoWidth = 225;

    // Other fonts
    if (locale === 'ja') {
      paragraphOneX = 312;
      paragraphOneY = 220;
      paragraphTwoX = 80;
      paragraphTwoY = 256;

      lineOneWidth = 120;
      lineTwoWidth = 236;
    } else if (locale === 'tw') {
      // taiwanese font with english
      paragraphOneX = 195;
      paragraphOneY = 276;
      paragraphTwoX = 40;
      paragraphTwoY = 315;

      lineOneWidth = 240;
      lineTwoWidth = 205;
    }

    // paragraph 1
    new LangBitmapFontTextView({
      superview: this.box,
      x: 40,
      y: 100,
      width: this.box.style.width - 80,
      align: 'center',
      verticalAlign: 'center',
      size: 28,
      color: 'white',
      wordWrap: true,
      font: bitmapFonts('Title'),
      isRichText: true,
      localeText: () => i18n('platform.line.terms.minimumAge'),
    });

    const isJa = locale === 'ja';
    let y = isJa ? 182 : 186;

    // paragraph 2
    new LangBitmapFontTextView({
      superview: this.box,
      x: 40,
      y,
      width: this.box.style.width - 80,
      align: 'center',
      verticalAlign: 'center',
      size: 28,
      color: 'white',
      wordWrap: true,
      font: bitmapFonts('Title'),
      isRichText: true,
      forceWrap: true,
      localeText: () => i18n('platform.line.terms.info'),
    });

    // only english and japanese for now
    // underline link for "Terms of Service"
    this.createUnderlineLink({
      x: paragraphOneX,
      y: paragraphOneY,
      width: lineOneWidth,
      height: 37,
      thickness: 6,
      onClick: async () => {
        await openPopupPromise('popupTermsPolicyDetails', { mode: 'tos' });
      },
    });
    // underline link for "Privacy Policy"
    this.createUnderlineLink({
      x: paragraphTwoX,
      y: paragraphTwoY,
      width: lineTwoWidth,
      height: 37,
      thickness: 6,
      onClick: async () => {
        await openPopupPromise('popupTermsPolicyDetails', { mode: 'pp' });
      },
    });

    // CONFIRM button
    new ButtonScaleViewWithText({
      ...uiConfig.buttons.primary,
      superview: this.box,
      labelOffsetY: -1,
      localeText: () => i18n('platform.line.terms.cta'),
      fontSize: 40,
      font: bitmapFonts('Title'),
      x: this.box.style.width / 2,
      y: this.box.style.height - 70,
      width: 240,
      height: 78,
      centerOnOrigin: true,
      onClick: async () => {
        trackToSConfirm();
        creationOpts.close();
      },
      tracking: {
        feature: 'terms',
        $subFeature: 'popup-terms-policy-confirm',
      },
    });
  }

  createUnderlineLink({ x, y, width, height, thickness, onClick }) {
    const container = new ButtonView({
      superview: this.box,
      zIndex: 10,
      x,
      y,
      width,
      height,
      onClick,
    });

    // Fake underline
    const lineOutline = new View({
      superview: container,
      height: thickness,
      backgroundColor: 'black',
      width,
      x: 0,
      y: height - thickness,
      canHandleEvents: false,
    });
    const borderSize = Math.round(thickness * 0.3);
    const lineFill = new View({
      superview: lineOutline,
      x: borderSize,
      y: borderSize,
      backgroundColor: 'white',
      width: width - borderSize * 2,
      height: thickness - borderSize * 2,
      canHandleEvents: false,
    });
  }

  init() {
    super.init({ title: i18n('platform.line.terms.title') });
    trackToSView();
  }
}
